import api from '~/services/api';
import { v4 } from 'uuid';
import { toast } from 'react-toastify';
import { formatCurrencyAsText } from '~/utils/functions';

export async function updateItensFiscal(
    cod_seq_cupom: string | number | undefined, payload: any
): Promise<any> {
    try {
        const { data } = await api.post(`/manutencao-fiscal/fiscal-nfce/${cod_seq_cupom}`, payload);
        if (data.success) {
            return toast.success('NCM de Item atualizado com sucesso!')
        }
    } catch (error: any) {
        return toast.warning('Itens da NF não encontrado');
    }
}
